package com.xtream.core_model.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MovieSubtitle(
    @SerialName("subtitles")
    val subtitles: List<Subtitle?>?,
    @SerialName("title")
    val title: String?
) {
    @Serializable
    data class Subtitle(
        @SerialName("language")
        val language: String?,
        @SerialName("language_code")
        val languageCode: String?,
        @SerialName("url")
        val url: String?
    )
}